import { Box, styled } from "@mui/material";


export const MainContainer = styled(Box)(({ theme }) => ({
    width: "100%",
    maxWidth: "1920px",
    margin: "0 auto",
    padding: "2em 1em",
    [theme.breakpoints.down('lg')]: {
        maxWidth: "1440px",
    },
    [theme.breakpoints.down('md')]: {
        maxWidth: "1136px",
    },
}))